import { authedFetch } from '@features/auth/api/authRefresh'
import { type FolderEncryptedResponse, type VaultCipherBlob } from '../types'

/**
 * Folder REST API client (T-D-Vault-Folder、Phase 4)。
 *
 * backend `apps/api/src/vault/folder.controller.ts` と 1:1。
 * フォルダ名は AES-256-GCM 暗号化済 cipher として送受信し、サーバは名前を知らない。
 */

const FOLDER_BASE = '/vault/folders'

export interface FolderWireRequest {
  ciphertext: string
  iv: string
  authTag: string
}

const toWireRequest = (cipher: VaultCipherBlob): FolderWireRequest => ({
  ciphertext: cipher.ciphertext,
  iv: cipher.iv,
  authTag: cipher.authTag,
})

/** GET /api/vault/folders — 自分の全フォルダ (作成日昇順)。 */
export const listFolders = (): Promise<FolderEncryptedResponse[]> =>
  authedFetch<FolderEncryptedResponse[]>(FOLDER_BASE)

/** POST /api/vault/folders — 新規作成 (201)。 */
export const createFolder = (cipher: VaultCipherBlob): Promise<FolderEncryptedResponse> =>
  authedFetch<FolderEncryptedResponse>(FOLDER_BASE, {
    method: 'POST',
    body: toWireRequest(cipher),
  })

/** PUT /api/vault/folders/:id — 名前更新。 */
export const updateFolder = (
  id: string,
  cipher: VaultCipherBlob,
): Promise<FolderEncryptedResponse> =>
  authedFetch<FolderEncryptedResponse>(`${FOLDER_BASE}/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body: toWireRequest(cipher),
  })

/** DELETE /api/vault/folders/:id — 204 No Content。関連 VaultItem.folderId は SetNull。 */
export const deleteFolder = async (id: string): Promise<void> => {
  await authedFetch<void>(`${FOLDER_BASE}/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  })
}
